export default __webpack_public_path__ + "static/media/blue-right.00d2a30f.svg";